import { useEffect, useState } from 'react';
import OrderApi from '../../Api/OrderApi';
import { Order } from '../../Models/Order';
import Loader from '../Common/Loader';
import { Button } from 'flowbite-react';
import { useAppSelector } from '../../Reducers/store';
import { Link } from 'react-router-dom';

export default function OrderConfirmation() {
  return (
    <>
      <div className='w-full mt-4'>
        <div className='container mx-auto p-2 h-[calc(100vh-80px)] lg:h-[calc(100vh-142px)] overflow-y-auto'>
          <div className='w-full mb-2 flex justify-between'>
            <div className='flex flex-col px-0 text-md lg:px-5 md:text-lg lg:text-xl items-center w-full'>
              <div className='font-bold content-center mb-5'>
                Thank you for submitting your order
              </div>
              <div className='font-bold content-center'>
                For additional questions:
              </div>
              <div className='font-bold content-center'>(770) 983-4376</div>
              <div className='font-bold content-center'>
                admin@fuelprousa.com
              </div>
              <div className='flex gap-2 mt-5'>
                <div>
                  <Link to={`/`}>
                    <Button className='buttonMain'>Return Home</Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
